import {default as gr} from './gr.json'
import {default as en} from './en.json'

export default {
	gr,
	en
}
